/*=========================================================================================
  File Name: module-usertax-state.js
  Description: UserTax Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	AuditingLogs: [],
	AuditingLogTotal: 0
};
